const REACT_APP_GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const REACT_APP_GOOGLE_CLIENT_SECRET = process.env.REACT_APP_GOOGLE_CLIENT_SECRET;

// Add this new function to handle initial token storage
export function storeTokens(tokens) {
  localStorage.setItem("google_access_token", tokens.access_token);
  if (tokens.refresh_token) {
    localStorage.setItem("google_refresh_token", tokens.refresh_token);
  }
}

async function refreshTokens() {
  const refreshToken = localStorage.getItem("google_refresh_token");
  if (!refreshToken) throw new Error("No refresh token available");

  try {
    const response = await fetch("https://oauth2.googleapis.com/token", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({
        client_id: REACT_APP_GOOGLE_CLIENT_ID, // Use constant directly
        client_secret: REACT_APP_GOOGLE_CLIENT_SECRET, // Use constant directly
        refresh_token: refreshToken,
        grant_type: "refresh_token",
      }),
    });

    if (!response.ok) {
      throw new Error("Failed to refresh token");
    }

    const data = await response.json();
    localStorage.setItem("google_access_token", data.access_token);
    return data.access_token;
  } catch (error) {
    console.error("Token refresh failed:", error);
    // Clear tokens if refresh fails
    localStorage.removeItem("google_access_token");
    localStorage.removeItem("google_refresh_token");
    throw error;
  }
}

async function makeAuthorizedRequest(url, options) {
  let accessToken = localStorage.getItem("google_access_token");

  try {
    const response = await fetch(url, {
      ...options,
      headers: {
        ...options.headers,
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (response.status === 401) {
      // Token expired, try to refresh
      accessToken = await refreshTokens();
      // Retry the request with new token
      return await fetch(url, {
        ...options,
        headers: {
          ...options.headers,
          Authorization: `Bearer ${accessToken}`,
        },
      });
    }

    return response;
  } catch (error) {
    console.error("Request failed:", error);
    throw error;
  }
}

export async function addCalendarEvent(eventDetails) {
  const event = {
    summary: eventDetails.summary,
    description: eventDetails.description,
    start: {
      dateTime: eventDetails.start,
      timeZone: "America/Toronto",
    },
    end: {
      dateTime: eventDetails.end,
      timeZone: "America/Toronto",
    },
  };

  const response = await makeAuthorizedRequest(
    "https://www.googleapis.com/calendar/v3/calendars/primary/events",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(event),
    }
  );

  if (!response.ok) {
    const error = await response.json();
    console.error("Google Calendar API error:", error);
    throw new Error("Failed to add event to calendar.");
  }

  return await response.json();
}

// ...existing code for addCalendarEvents remains the same...


  export async function addCalendarEvents(events) {
    for (const event of events) {
      try {
        await addCalendarEvent(event);
        console.log("Added event:", event.summary);
      } catch (err) {
        console.error("Failed to add event:", event.summary, err);
      }
    }
  }
  